const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.292 5.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M108.021 143.806h-3.704a.796.796 0 0 0-.794.794v3.704c0 .436.357.794.794.794h3.704a.796.796 0 0 0 .794-.794V144.6a.796.796 0 0 0-.794-.794m-.029 1.177-.733 1.469a.78.78 0 0 1-.577.423.78.78 0 0 1-.682-.22.26.26 0 0 0-.233-.07.25.25 0 0 0-.188.15l-.765 1.429a.26.26 0 0 1-.357.108.263.263 0 0 1-.108-.357l.754-1.408a.77.77 0 0 1 .563-.442.79.79 0 0 1 .707.217.258.258 0 0 0 .412-.068l.736-1.469a.263.263 0 0 1 .355-.116c.13.063.182.222.116.354",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-103.523 -143.806)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.dab9fbd31ae56af5a107402045c912fa.svg";
export { ForwardRef as ReactComponent };